import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { catalogPath, type ProductType } from "@/lib/url-slugs";
import {
  IconPingPong,
  IconShirtSport,
  IconShoe,
  IconBackpack,
  IconBallTennis,
  IconConePlus,
} from "@tabler/icons-react";

const categories: Array<
  { tKey: "nav.rackets" | "nav.apparel" | "nav.shoes" | "nav.bags" | "nav.balls" | "nav.accessories"; type: ProductType; Icon: any }
> = [
  { tKey: "nav.rackets", type: "rackets", Icon: IconPingPong },
  { tKey: "nav.apparel", type: "apparel", Icon: IconShirtSport },
  { tKey: "nav.shoes", type: "shoes", Icon: IconShoe },
  { tKey: "nav.bags", type: "bags", Icon: IconBackpack },
  { tKey: "nav.balls", type: "balls", Icon: IconBallTennis },
  { tKey: "nav.accessories", type: "accessories", Icon: IconConePlus },
];

const CategoryButtons = () => {
  const { t, lang } = useLanguage();

  return (
    <section className="container mx-auto px-4 py-12 md:py-16">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
        {categories.map((cat) => {
          const href = catalogPath(lang, cat.type);
          return (
            <Link
              key={href}
              to={href}
              className="group flex flex-col items-center gap-3 p-6 bg-card rounded-xl border border-border shadow-sm hover:shadow-md hover:border-accent transition-all"
            >
              <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                <cat.Icon
                  size={28}
                  stroke={1.5}
                  className="text-primary group-hover:text-accent transition-colors"
                />
              </div>
              <span className="font-display font-semibold text-sm text-foreground group-hover:text-primary transition-colors">
                {t(cat.tKey)}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default CategoryButtons;
